import { DayPerformance, ScoreResume } from 'types';
import { convertTimestampToDate } from 'helpers';

function populateDaysPerformance(daysPerformance: any = []): DayPerformance[] {
  return daysPerformance.map((dayPerformance: any) => {
    const { confirmedQuantity, date, revokedQuantity } = dayPerformance;

    return {
      confirmedQuantity: confirmedQuantity || 0,
      date: convertTimestampToDate(date || 0),
      revokedQuantity: revokedQuantity || 0,
    };
  });
}

export function scoreResumeFactory(params: any = {}): ScoreResume {
  const { daysPerformance, priority } = params;

  return {
    daysPerformance: populateDaysPerformance(daysPerformance || []),
    priority: priority || 0,
  };
}
